module.exports = __webpack_public_path__ + "img/bottom_brand logo.e21e22b4.svg";